import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { ResetPasswordForm } from '@/features/auth/components/reset-password-form';

const resetPasswordSearchSchema = z.object({
  token: z.string().optional(),
});

export const Route = createFileRoute('/_public/reset-password')({
  validateSearch: resetPasswordSearchSchema,
  beforeLoad: ({ search }) => {
    // Redirect to forgot-password if no token provided
    if (!search.token) {
      throw redirect({ to: '/forgot-password' });
    }
  },
  component: ResetPasswordPage,
});

function ResetPasswordPage() {
  const { token } = Route.useSearch();
  return <ResetPasswordForm token={token!} />;
}
